<template>
  <Modal
    title="Set Accounting Class"
    class-name="invoice-accounting-modal"
    :saving="saving"
    :disabled="!classId"
    @submit="handleSave"
  >
    <div>
      <Select
        v-model="classId"
        :validation-errors="v$.$errors"
        name="Accounting Class"
        :options="accountingClassOptions"
        class="flex-1"
        :field-error="firstErrorMessage(v$.classId)"
      >
        <template #item-row="{ option }">
          <div class="option-row">
            <span :class="{ 'strike-through': option.archived }">
              {{ option.label }}
            </span>
          </div>
        </template>
      </Select>
    </div>
  </Modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { firstErrorMessage } from "@/lib/vuelidate_helpers";

import Modal from "@/components/Modal.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
export default {
  components: {
    Modal
  },
  props: {
    invoiceId: {
      type: Number,
      default: null
    },
    accountingClassId: {
      type: Number,
      default: null
    }
  },
  emits: ["hide-modal", "save-success"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      classId: this.accountingClassId,
      saving: false
    };
  },
  computed: {
    ...mapGetters(["accountingClassOptions"])
  },
  mounted() {
    if (!this.accountingClassOptions.length) {
      this.fetchAccountingClasses();
    }
  },
  validations() {
    return {
      classId: { required, $autoDirty: true }
    };
  },
  methods: {
    firstErrorMessage,
    ...mapActions(["fetchAccountingClasses", "updateInvoiceAccountingClass"]),
    async handleSave() {
      const valid = await this.v$.$validate();
      if (!valid) return;
      this.saving = true;
      this.updateInvoiceAccountingClass({
        invoiceId: this.invoiceId,
        accounting_class_id: this.classId
      })
        .then(() => {
          this.$emit("hide-modal");
          this.$emit("save-success");
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>

<style lang="scss">
.invoice-accounting-modal {
  .modal-dialog {
    max-width: 500px;
  }
}
</style>
